import axios from "./AxiosClient";

const url = `/api`;

const FormsService = {
  getUserOtherForms: (userId, page = 1) => {
    return axios.get(`${url}/forms/otherForms/${userId}?page=${page}`);
  },
  assignForms: (userId, formIds) => {
    return axios.post(`${url}/forms/assign`, {
      user_id: userId,
      form_id: formIds,
    });
  },
  assignFormsToUser: (formId, userIds) => {
    return axios.post(`${url}/forms/assignUsers`, {
      user_id: userIds,
      form_id: formId,
    });
  },
};

export default FormsService;
